import { defaultBreakpoints } from '@ad-lucy/context/ThemeProvider/constants';

import type { Theme } from './types';
import {
  backgroundColorBackdrop,
  backgroundColorDark,
  backgroundColorLight,
  colorTextDark,
} from './values';

export const defaultTheme: Theme = {
  breakpoints: defaultBreakpoints,
  colors: {
    backgroundColorLight,
    backgroundColorDark,
    backgroundColorBackdrop,
    colorTextDark,
  },
  layers: {
    zIndexContent: 20,
    zIndexFooter: 100,
    zIndexHeader: 1100,
    zIndexImage: 10,
    zIndexLayer: 80,
    zIndexPricePatch: 70,
    zIndexMobileLayerButton: 90,
    zIndexModal: 10000,
    zIndexSticky: 110,
    zIndexStickyText: 60,
    zIndexStoryline: 100,
    zIndexNavButton: 120,
  },
  typos: {
    fontFamily: '"Arial", "Helvetica", sans-serif',
    fontSizeTextNormal: '16px',
    lineHeightTextNormal: '24px',
    fontWeightNormal: '400',
    fontWeightBold: '600',
  },
};
